import { axios, fetcher } from '@/utils/request';


export default {
  // pv指数上报
  pv_report(params) {
    return axios({
      url: 'service/pv/pv_report',
      method: 'post',
      data: params,
    });
  },
  // 获取缺陷详情 数据
  getInsideQxTop(data) {
    return fetcher({
      url: '/service/tianshu_persona/detail/inside_qx_top',

      method: 'get',
      data,
    });
  },
  // 获取缺陷详情占比 数据
  getInsideQxRate(data) {
    return fetcher({
      url: '/service/tianshu_persona/detail/inside_qx_rate',
      method: 'get',
      data,
    });
  },
  // 获取缺陷详情表格 数据
  getInsideQxDetailQuery(data) {
    return fetcher({
      url: '/service/tianshu_persona/detail/inside_qx_detail_query',
      method: 'get',
      data,
    });
  },
  // 获取缺陷详情表格 数据 - 导出
  getInsideQxDetailExport(data) {
    return fetcher({
      url: '/service/tianshu_persona/detail/inside_qx_detail_export',
      method: 'get',
      data,
    });
  },
  // 获取任务类型
  geyTasktype(data) {
    return fetcher({
      url: '/service/tianshu_persona/detail/inside_qx_top',
      method: 'get',
      data,
    });
  },
};
